// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-container {
  position: absolute; /* or absolute */
  top: 30%;
  width: 32vw;
  background: white;
  border-radius: 0.6vw;
  padding: 1.2vw;
  outline: none;
  border: none;
}

.search-modal-title{
    font-family: "Poppins";
    font-weight: 600;
    font-size: .8vw;
    line-height: 1.1vw;
    letter-spacing: 0%;
    color:"#595959";
}

.karat-header{
    font-family: "Poppins";
    font-weight: 500;
    font-size: .8vw;
    line-height: 100%;
    letter-spacing: 0%;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/infoModal/infoModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAE,gBAAgB;EACpC,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".summary-container {\n  position: absolute; /* or absolute */\n  top: 30%;\n  width: 32vw;\n  background: white;\n  border-radius: 0.6vw;\n  padding: 1.2vw;\n  outline: none;\n  border: none;\n}\n\n.search-modal-title{\n    font-family: \"Poppins\";\n    font-weight: 600;\n    font-size: .8vw;\n    line-height: 1.1vw;\n    letter-spacing: 0%;\n    color:\"#595959\";\n}\n\n.karat-header{\n    font-family: \"Poppins\";\n    font-weight: 500;\n    font-size: .8vw;\n    line-height: 100%;\n    letter-spacing: 0%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
